import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonContainer, Modal, ModalFooter, Typography } from '@emburse/embark-core';
import { $t, useTranslation } from '../../../../hooks/useTranslation';
function ManageUsersLeaveModal({ onConfirm, onClose, open }) {
    useTranslation();
    const confirmHandler = (e, save) => {
        onClose();
        onConfirm(e, save);
    };
    const closeHandler = () => {
        onClose();
    };
    const modalFooter = () => (_jsx(ModalFooter, { children: _jsxs(ButtonContainer, { alignButtons: "right", children: [_jsx(Button, { variant: "outlined", onClick: closeHandler, children: $t('Cancel') }), _jsx(Button, { variant: "outlined", onClick: (e) => confirmHandler(e, false), children: $t('Continue anyway') }), _jsx(Button, { color: "primary", onClick: (e) => confirmHandler(e, true), children: $t('Save and continue') })] }) }));
    return (_jsx(Modal, { size: "sm", open: open, modalHeader: $t('Leave page?'), modalFooter: modalFooter(), onClose: closeHandler, children: _jsx(Typography, { children: $t('Changes you made may not be saved.') }) }));
}
export default ManageUsersLeaveModal;
